/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

export default function themeTypography(theme) {
  return {
    fontFamily: theme?.customization?.fontFamily || '"Inter", "Helvetica", "Arial", sans-serif',
    h6: {
      fontWeight: 600,
      color: theme.heading,
      fontSize: '0.875rem',
      letterSpacing: '0.5px'
    },
    h5: {
      fontSize: '1rem',
      color: theme.heading,
      fontWeight: 600,
      letterSpacing: '0.5px'
    },
    h4: {
      fontSize: '1.125rem',
      color: theme.heading,
      fontWeight: 600,
      letterSpacing: '0.5px'
    },
    h3: {
      fontSize: '1.5rem',
      color: theme.heading,
      fontWeight: 700,
      letterSpacing: '0.5px'
    },
    h2: {
      fontSize: '1.75rem',
      color: theme.heading,
      fontWeight: 700,
      letterSpacing: '0.5px'
    },
    h1: {
      fontSize: '2.25rem',
      color: theme.heading,
      fontWeight: 700,
      letterSpacing: '0.5px'
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: theme.textDark,
      letterSpacing: '0.5px'
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 500,
      color: theme.darkTextSecondary,
      letterSpacing: '0.5px'
    },
    caption: {
      fontSize: '0.75rem',
      color: theme.darkTextSecondary,
      fontWeight: 400,
      letterSpacing: '0.5px'
    },
    body1: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.5',
      letterSpacing: '0.5px'
    },
    body2: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '1.5',
      letterSpacing: '0.5px',
      color: theme.darkTextPrimary
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '0.5px'
    },
    customInput: {
      marginTop: 1,
      marginBottom: 1,
      '& > label': {
        top: 23,
        left: 0,
        color: theme.grey500,
        '&[data-shrink="false"]': {
          top: 5
        }
      },
      '& > div > input': {
        padding: '30.5px 14px 11.5px !important'
      },
      '& legend': {
        display: 'none'
      },
      '& fieldset': {
        top: 0
      }
    },
    mainContent: {
      backgroundColor: theme.background,
      width: '100%',
      minHeight: 'calc(100vh - 88px)',
      flexGrow: 1,
      padding: '24px',
      marginTop: '88px',
      marginRight: '24px',
      borderRadius: '12px'
    },
    menuCaption: {
      fontSize: '0.875rem',
      fontWeight: 600,
      color: theme.heading,
      padding: '8px',
      textTransform: 'capitalize',
      marginTop: '12px',
      letterSpacing: '0.5px'
    },
    subMenuCaption: {
      fontSize: '0.75rem',
      fontWeight: 500,
      color: theme.darkTextSecondary,
      textTransform: 'capitalize',
      letterSpacing: '0.5px'
    },
    commonAvatar: {
      cursor: 'pointer',
      borderRadius: '8px'
    },
    smallAvatar: {
      width: '24px',
      height: '24px',
      fontSize: '1rem'
    },
    mediumAvatar: {
      width: '36px',
      height: '36px',
      fontSize: '1.2rem'
    },
    largeAvatar: {
      width: '48px',
      height: '48px',
      fontSize: '1.5rem'
    }
  };
}
